import { defineMessages } from "react-intl";

const PREFIX = "Subscriptions.SubscriptionsSettings.Actions";
export const messages = defineMessages({
  save: {
    id: `${PREFIX}.save`,
    defaultMessage: "Save",
  },
  cancel: {
    id: `${PREFIX}.cancel`,
    defaultMessage: "Cancel",
  },
  delete: {
    id: `${PREFIX}.delete`,
    defaultMessage: "Delete",
  },
});
